import React from "react";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import { useDispatch, useSelector } from "react-redux";

const GroupBySubscription = () => {
  const dispatch = useDispatch();
  const groupBySubscription = useSelector(
    (state) => state.onDemandRevenue.selectedFilters.groupBySubscription
  );

  const handleUpdateGroupBySubscriptions = (isActive) => {
    dispatch(actionCreators.updateSelectedFilters({ groupBySubscription: isActive }));
  };

  return (
    <ToggleableButton
      isActive={groupBySubscription}
      isRadio
      onClick={handleUpdateGroupBySubscriptions}
    />
  );
};

export default GroupBySubscription;
